import { Endpoints } from "../constants/endpoint";
import axios from "axios";

export const GetAllParagraphs = async () => {
    try {
        const res = await fetch(Endpoints.paragraphs);
        console.log(res)
        if (!res.ok) {
            throw new Error(`HTTP error! status: ${res.status}`);
        }
        const data = await res.json();
        return data
    } catch (err) {
        return err.message;
    }
}

export const CreateParagraph = async (payload) => {
    const options = {
        method: 'POST',
        headers: {
            'Accept': "application/json",
            'Content-Type': "application/json;charset=utf-8"
        },
        body: JSON.stringify(payload)
    };
    try {
        const res = await fetch(Endpoints.paragraphs, options);
        if (!res.ok) {
            throw new Error(`HTTP error! status: ${res.status}`);
        }
        const data = await res.json();
        return data
    } catch (err) {
        return err.message;
    }
}

export const EditParagraph = async (payload, id) => {
    const options = {
        method: 'PUT',
        headers: {
            'Accept': "application/json",
            'Content-Type': "application/json;charset=utf-8"
        },
        body: JSON.stringify(payload)
    };
    try {
        const res = await fetch(Endpoints.paragraphs + id, options);
        if (!res.ok) {
            throw new Error(`HTTP error! status: ${res.status}`);
        }
        const data = await res.json();
        return data
    } catch (err) {
        return err.message;
    }
}

export const DeleteParagraph = async (id) => {
    const options = {
        method: 'DELETE',
        headers: {
            'Accept': "application/json",
            'Content-Type': "application/json;charset=utf-8"
        }
    };
    try {
        const res = await fetch(Endpoints.paragraphs + id, options);
        if (!res.ok) {
            throw new Error(`HTTP error! status: ${res.status}`);
        }
        const data = await res.json();
        return data
    } catch (err) {
        return err.message;
    }
}


export const CreateParagraphs = async (payload) => {
    const options = {
        method: 'POST',
        headers: {
            'Accept': "application/json",
            'Content-Type': "application/json;charset=utf-8"
        },
        body: JSON.stringify(payload)
    };
    try {
        const res = await fetch(Endpoints.paragraphs, options);
        if (!res.ok) {
            throw new Error(`HTTP error! status: ${res.status}`);
        }
        const data = await res.json();
        return data
    } catch (err) {
        return err.message;
    }
}

export const CreateParagraphsBulk = async (payload) => {
    const options = {
        method: 'POST',
        headers: {
            'Accept': "application/json",
            'Content-Type': "application/json;charset=utf-8"
        },
        body: JSON.stringify(payload)
    };
    try {
        const res = await fetch(Endpoints.paragraphs + "bulk", options);
        if (!res.ok) {
            throw new Error(`HTTP error! status: ${res.status}`);
        }
        const data = await res.json();
        return data
    } catch (err) {
        return err.message;
    }
}

export const EditParagraphs = async (payload, params) => {
    const options = {
        method: 'PUT',
        headers: {
            'Accept': "application/json",
            'Content-Type': "application/json;charset=utf-8"
        },
        body: JSON.stringify(payload)
    };
    try {
        const res = await fetch(Endpoints.paragraphs + params, options);
        if (!res.ok) {
            throw new Error(`HTTP error! status: ${res.status}`);
        }
        const data = await res.json();
        return data
    } catch (err) {
        return err.message;
    }
}

// Strict on purpose, unlike its neighbours: a failed regeneration must
// reject the thunk. The editor puts the reply straight into the text field
// and its autosave writes it back, so a swallowed error used to end up
// saved into the paragraph — as `undefined`, or as the server's error text.
export const RegenerateParagraphContent = async (payload) =>
    strictJson(Endpoints.paragraphs + "regenerate_paragraph_corrected_content_with_ai", {
        method: 'POST', headers: JSON_HEADERS, body: JSON.stringify(payload)
    });

// ──────────────────────────────────────────────────────────────────────────
// Strict variants for undo.
//
// The functions above catch their own errors and return err.message as a
// STRING, so a failed request is indistinguishable from a successful one at
// the call site. Undo cannot work that way: if a restore fails it must not
// look like it succeeded, or the entry is popped and the change is lost.
// These propagate instead. Used only by redux/undo.
// ──────────────────────────────────────────────────────────────────────────

const strictJson = async (url, options) => {
    const res = await fetch(url, options);
    const text = await res.text();
    if (!res.ok) {
        // Prefer the server's own explanation when it sent one.
        let detail = "";
        try { detail = JSON.parse(text)?.error || ""; } catch { /* not JSON */ }
        throw new Error(detail || `HTTP ${res.status} for ${options?.method || "GET"} ${url}`);
    }
    return text ? JSON.parse(text) : null;
};

const JSON_HEADERS = {
    'Accept': "application/json",
    'Content-Type': "application/json;charset=utf-8"
};

/** Returns the paragraph, or null when it no longer exists. */
export const GetParagraphById = async (id) => {
    const res = await fetch(Endpoints.paragraphs + id, { method: 'GET', headers: JSON_HEADERS });
    if (res.status === 404) return null;
    if (!res.ok) throw new Error(`HTTP ${res.status} reading paragraph ${id}`);
    const text = await res.text();
    return text ? JSON.parse(text) : null;
};

/** Recreates a paragraph. The id in the payload is preserved by the backend. */
export const CreateParagraphStrict = async (payload) =>
    strictJson(Endpoints.paragraphs, {
        method: 'POST', headers: JSON_HEADERS, body: JSON.stringify(payload)
    });

export const EditParagraphStrict = async (payload, id) =>
    strictJson(Endpoints.paragraphs + id, {
        method: 'PUT', headers: JSON_HEADERS, body: JSON.stringify(payload)
    });

export const DeleteParagraphStrict = async (id) =>
    strictJson(Endpoints.paragraphs + id, { method: 'DELETE', headers: JSON_HEADERS });
